<template>
	<div>
		<ProfileBlock :title="$t('components.profile_edit.block_name')">
			<FormulateForm id="profile-form" v-model="form" @submit="submit" :keep-model-data="true">
				<FormulateInput
					type="select"
					name="title"
					:label="$t('components.profile_edit.title_label')"
					:options="$t('components.profile_edit.title_options')"
				/>
				<FormulateInput
					type="text"
					name="first_name"
					:label="$t('components.profile_edit.first_name_label')"
					required
				/>
				<FormulateInput
					type="text"
					name="last_name"
					:label="$t('components.profile_edit.last_name_label')"
					required
				/>
			</FormulateForm>
			<template v-slot:block-link>
				<button type="submit" form="profile-form">{{$t('components.profile_edit.save_button')}}</button>
			</template>
		</ProfileBlock>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations } from "vuex";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "ProfileName",
    components: {ProfileBlock},
    methods: {
    	submit() {
            this.updateProfileInfo()
                .then(() => {
                    this.$toast.success(this.$t("components.profile_edit.success_message").toString());
                })
        },
        ...mapActions({
            "fetch": "profile/fetch",
            "updateProfileInfo": "profile/updateProfileInfo"
        }),
        ...mapMutations({"SET_PROFILE_INFO": "profile/SET_PROFILE_INFO"})
    },
    computed: {
    	form: {
    		get() {
    			return this.profile_info
            },
            set(value) {
    			console.log(value);
                this.SET_PROFILE_INFO(value);
            }
        },
        ...mapGetters({"profile_info": "profile/profile_info"})
    },
    mounted() {
        this.fetch();
    }
};
</script>
